import React, { useState, useEffect } from "react";
import { Grid } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CloseQut = (props) => {
    const [Mode, setMode] = useState('');
    const [QuotationLostRemarks, setQuotationLostRemarks] = useState('');
    const [QuotationLostReasonCodeID, setQuotationLostReasonCodeID] = useState('');
    const [QuotationLostWonBy, setQuotationLostWonBy] = useState('');
    const [QuotationLostReasonCodecmb, setQuotationLostReasonCodecmb] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    // const [responseGetData, fetchDataGetData] = UseFetchData();
    const [Qstage, setQstage] = useState("false");


    const validationSchema = Yup.object({
        QuotationLostRemarks: Yup.string().required('Required!'),
        QuotationLostWonBy: Yup.string().required('Required!'),
    });

    const onSubmit = values => {
        // setMode("Insert")
        var QuotationLostUpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        var QuotationStage = 'Closed';

        // if (props.Mode === "Insert") {
        //     QuotationID = '';
        // }
        // else {
        //     QuotationID = props.QuotationID;
        //     var QuotationStage = 'Budgetary Quotations';
        // }
        if (Qstage == "true") {
            QuotationStage = 'BudgetaryQuotations';
        }
        // debugger;
        bodyFormData.append("QuotationID", props.QuotationID);
        bodyFormData.append("QuotationLostReasonCodeID", QuotationLostReasonCodeID);
        bodyFormData.append("QuotationLostRemarks", values.QuotationLostRemarks);
        if (Qstage == "true") {
            bodyFormData.append("QuotationStage", QuotationStage);
        } else {
            bodyFormData.append("QuotationStage", QuotationStage);
        }
        bodyFormData.append("QuotationLostWonBy", values.QuotationLostWonBy);
        bodyFormData.append("QuotationLostUpdatedByID", QuotationLostUpdatedByID);
        fetchData("Quotation/QutCloseSave", bodyFormData);
    }

    useEffect(() => {
        // debugger;
        if ((response.Response === true)) {
            if (response.Message.includes('Closed') === true) {
                alert(response.Message);
            }
            else {
                alert(response.Message);
            }
            props.setisOpenCloseQut(false);
            props.PopulateData();
        }
        else if (response.Response === false) {
            alert('Failed.');
        }
    }, [response])


    const QuotationLostReasonCodeData = (options) => {
        // debugger;
        if (options !== undefined) {
            let ReasonCode = options.map((data) => (
                <option key={data.QuotationLostReasonCode} value={data.QuotationLostReasonCodeID}>
                    {data.QuotationLostReasonCode}
                </option>
            ));
            setQuotationLostReasonCodecmb(ReasonCode);
        }
    };

    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (
                ComboDataResponse["QuotationLostReasonCode"] !== undefined
            ) {
                QuotationLostReasonCodeData(ComboDataResponse["QuotationLostReasonCode"]);

            }
        }
    }, [ComboDataResponse]);


    const GetComboData = () => {
        fetchComboData("Quotation/ComboDataCloseQUT");
    };

    const onUpdate = () => {
        setQstage("true");
    };

    useEffect(() => {
        GetComboData();
    }, []);

    useEffect(() => {
        debugger;
        if (props.QuotationMainData !== undefined && props.QuotationMainData.length > 0) {
            setQuotationLostReasonCodeID(props.QuotationMainData[0].QuotationLostReasonCodeID)
            setQuotationLostRemarks(props.QuotationMainData[0].QuotationLostRemarks);
            setQuotationLostWonBy(props.QuotationMainData[0].QuotationLostWonBy);

        }
    }, [props.QuotationMainData]);


    return (
        <div>
            <Formik initialValues={{
                QuotationLostRemarks: QuotationLostRemarks, QuotationLostWonBy: QuotationLostWonBy, QuotationLostReasonCodeID: QuotationLostReasonCodeID,
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={5}>
                                <label htmlFor={"QuotationLostReasonCode"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"QutLostReasonCode"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='QuotationLostReasonCodeID'
                                    options={QuotationLostReasonCodecmb}
                                    onChange={(e) => setQuotationLostReasonCodeID(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={5}>
                                <label
                                    htmlFor={"QuotationLostRemarks"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"QuotationLostRemarks"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='QuotationLostRemarks'
                                    onChange={(e) => setQuotationLostRemarks(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <label htmlFor={"QuotationLostWonBy"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"QuotationLostWonBy"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='QuotationLostWonBy'
                                    onChange={(e) => setQuotationLostWonBy(e.target.value)}
                                />
                            </Grid>

                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="UPDATE"
                                            type="submit"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { onUpdate() }}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setisOpenCloseQut(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
};

export default CloseQut;
